import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { RadioGroup } from "@tenant/ui";
import defaultStyles from "./FilterUserRating.module.scss";
import { useFilterUserRating } from "./hooks/useFilterUserRating";

type UserRatingProps = {
  value: number;
  onChange(nextValue: number): void;
};

export const UserRating = ({ value, onChange }: UserRatingProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.FilterUserRating,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreHotelsComponent.FilterUserRating
  );

  const { t } = useI18nContext();

  const { options } = useFilterUserRating();

  return (
    <div className={block}>
      <RadioGroup
        className={cn("radio-group")}
        defaultValue={value.toString()}
        onSelectValue={(value) => {
          const nextValue = value;
          onChange(Number(nextValue));
        }}
        aria-label={t("core-hotels.availabilityPage.filters.userRating.title")}
        options={options.map(({ toggleValue, title }) => ({
          label: title,
          value: toggleValue,
        }))}
      />
    </div>
  );
};
